import { Spacing, SpacingSizes } from "@components/Spacing";
import { PerformanceChartProvider } from "@contexts/PerformanceChartContext";
import { Canvas } from "./Canvas";
import { DateRangeValues } from "./DateRangeValues";
import { MainPath } from "./MainPath";
import { useStyles } from "./styles";
import { PerformanceChartProps } from "./types";

export const PerformanceChart = (props: PerformanceChartProps) => {
  return (
    <PerformanceChartProvider data={props.data}>
      <PerformanceChartComponent {...props} />
    </PerformanceChartProvider>
  );
};

export const PerformanceChartComponent = ({
  header,
  dateRanges = true,
  footer,
}: PerformanceChartProps) => {
  const styles = useStyles();

  return (
    <div style={styles.container}>
      {header}

      <Canvas>
        <MainPath />
      </Canvas>
      <Spacing size={SpacingSizes.M} />

      {dateRanges ? (
        <>
          <DateRangeValues />
          <Spacing size={SpacingSizes.S} />
        </>
      ) : null}

      {footer}
    </div>
  );
};
